import React, { useEffect } from 'react';
import { renderInputFieldWithoutLabel } from '../../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import { setEmbryologyData } from '../../../../actions/embryologyActions';
import DateComponent from '../../../Registrationform/components/dateComponent';
import { fetchEmbryologySummaryReport } from '../../../../api/embryologyApi';
import dayjs from 'dayjs';
import { toast } from 'sonner';
import { CustomTextArea } from '../../../../common/CustomTextArea';

const EmbryologySummaryReport = ({ cycleId, isDisabled }) => {
  const data = useSelector((state) => state.embryologyReducer);
  const summaryReport = useSelector(
    (state) => state.embryologyReducer.summaryReport,
  );

  const patientData = useSelector(
    (state) => state.embryologyReducer.selectedPatientData.patient,
  );
  const dispatch = useDispatch();

  const setFormData = (result) => {
    const summaryState = {
      name: '',
      partnerName: '',
      mpiNo: '',
      date: '',
      treatingDoctor: '',
      oocyteOrigin: '',
      semenOrigin: '',
      oocyteStatus: '',
      ovumPickupDate: '',
      retrievedOcc: '',
      noOfMatureOcytes: '',
      noOfImmatureOocytes: {
        mi: '',
        gv: '',
        others: '',
      },
      totalOocytesForICSI: '',
      totalOocytesForIVF: '',
      oocytesComments: '',
      preWash: {
        volume: '',
        concentration: '',
        totalMotility: '',
      },
      postWash: {
        volume: '',
        concentration: '',
        totalMotility: '',
      },
      spermComments: '',
      normalFertilization: '',
      gradeABCCount: '',
      embryoDevelopment: [
        {
          day: '',
          cellNoOrStage: '',
          grade: '',
          state: '',
        },
      ],
      totalUsableEmbryos: {
        day3: '',
        day5: '',
        day6: '',
      },
      numberOfEmbryosTransferred: {
        day3: '',
        day5: '',
        day6: '',
      },
      numberOfEmbryosBiopsy: {
        day3: '',
        day5: '',
        day6: '',
      },
      numberOfEmbryoCryopreserved: {
        day3: '',
        day5: '',
        day6: '',
      },
      numberOfEmbryoObservation: '',
      numberOfEmbryosDiscarded: '',

      reportComments: '',
      embryologist: '',
    };
    const summary = result.summary ? result.summary.summary : null;
    const oocyteRecord = result.oocyteRecord
      ? result.oocyteRecord.oocyteEmbryo
      : null;
    if (patientData) {
      summaryState.name = patientData.firstName + ' ' + patientData.lastName;
      summaryState.partnerName =
        patientData.partner.firstName + ' ' + patientData.partner.lastName;
      summaryState.mpiNo = patientData.upid;
      summaryState.date = dayjs().format('YYYY-MM-DD');
    }

    if (summary) {
      summaryState.treatingDoctor = summary.treatingDoctor;
      summaryState.oocyteOrigin = summary.sourceOfOocyte;
      summaryState.semenOrigin = summary.sperm;
      summaryState.oocyteStatus = summary.oocyteType;
      summaryState.retrievedOcc = summary.retrievedOCC;
      summaryState.ovumPickupDate = summary.date; //
      summaryState.noOfMatureOcytes = summary.denudationMii;
      summaryState.noOfImmatureOocytes.mi = summary.denudationMi;
      summaryState.noOfImmatureOocytes.gv = summary.denudationGv;
      summaryState.noOfImmatureOocytes.others = summary.denudationOther;
      summaryState.totalOocytesForICSI = summary.isciNumberOfMiiInjected;
      summaryState.totalOocytesForIVF = summary.ivfCoc;
      summaryState.oocytesComments = summary.occDenudationComment;
      summaryState.preWash.volume = summary.preWash.volume;
      summaryState.preWash.concentration = summary.preWash.concentration;
      summaryState.preWash.totalMotility = summary.preWash.totalMotility;
      summaryState.postWash.volume = summary.postWash.volume;
      summaryState.postWash.concentration = summary.postWash.concentration;
      summaryState.postWash.totalMotility = summary.postWash.totalMotility;
      summaryState.spermComments = summary.spermPreparationComment;
    }

    if (oocyteRecord) {
      console.log('oocyteRecord exist', oocyteRecord);
      let normalFertilizationCount = 0;
      let gradeACount = 0;
      let gradeBCount = 0;
      let gradeCCount = 0;
      let embryoDevelopment = [];
      for (let i = 0; i < oocyteRecord.day0.data.length; i++) {
        if (
          oocyteRecord.day1.data[i].pb === '2' &&
          oocyteRecord.day1.data[i].pn === '2'
        ) {
          normalFertilizationCount++;

          if (oocyteRecord.day2.data[i].grade === 'A') {
            gradeACount++;
          }
          if (oocyteRecord.day2.data[i].grade === 'B') {
            gradeBCount++;
          }
          if (oocyteRecord.day2.data[i].grade === 'C') {
            gradeCCount++;
          }

          if (oocyteRecord.day6.data[i].fate === 'Embryo Transfer') {
            embryoDevelopment.push({
              day: oocyteRecord.day6.data[i].day,
              cellNoOrStage:
                oocyteRecord.day6.data[i].cellNoOrGrade !== ''
                  ? oocyteRecord.day6.data[i].cellNoOrGrade.split(' ')[0]
                  : '',
              grade:
                oocyteRecord.day6.data[i].cellNoOrGrade !== ''
                  ? oocyteRecord.day6.data[i].cellNoOrGrade.split(' ')[1]
                  : '',
              state: oocyteRecord.day6.data[i].fate,
            });
          }

          if (oocyteRecord.day6.data[i].fate === 'Cryopreserve') {
            embryoDevelopment.push({
              day: oocyteRecord.day6.data[i].day,
              cellNoOrStage:
                oocyteRecord.day6.data[i].cellNoOrGrade !== ''
                  ? oocyteRecord.day6.data[i].cellNoOrGrade.split(' ')[0]
                  : '',
              grade:
                oocyteRecord.day6.data[i].cellNoOrGrade !== ''
                  ? oocyteRecord.day6.data[i].cellNoOrGrade.split(' ')[1]
                  : '',
              state: oocyteRecord.day6.data[i].fate,
            });
          }

          if (oocyteRecord.day6.data[i].fate === 'Embryobiopsy') {
            embryoDevelopment.push({
              day: oocyteRecord.day6.data[i].day,
              cellNoOrStage:
                oocyteRecord.day6.data[i].cellNoOrGrade !== ''
                  ? oocyteRecord.day6.data[i].cellNoOrGrade.split(' ')[0]
                  : '',
              grade:
                oocyteRecord.day6.data[i].cellNoOrGrade !== ''
                  ? oocyteRecord.day6.data[i].cellNoOrGrade.split(' ')[1]
                  : '',
              state: oocyteRecord.day6.data[i].fate,
            });
          }
        }

        if (oocyteRecord.day6.data[i].fate === 'Embryo Transfer') {
          if (oocyteRecord.day6.data[i].day === '3') {
            summaryState.numberOfEmbryosTransferred.day3 =
              summaryState.numberOfEmbryosTransferred.day3 === ''
                ? 1
                : summaryState.numberOfEmbryosTransferred.day3 + 1;
            summaryState.totalUsableEmbryos.day3 =
              summaryState.totalUsableEmbryos.day3 === ''
                ? 1
                : summaryState.totalUsableEmbryos.day3 + 1;
          }
          if (oocyteRecord.day6.data[i].day === '5') {
            summaryState.numberOfEmbryosTransferred.day5 =
              summaryState.numberOfEmbryosTransferred.day5 === ''
                ? 1
                : summaryState.numberOfEmbryosTransferred.day5 + 1;

            summaryState.totalUsableEmbryos.day5 =
              summaryState.totalUsableEmbryos.day5 === ''
                ? 1
                : summaryState.totalUsableEmbryos.day5 + 1;
          }
          if (oocyteRecord.day6.data[i].day === '6') {
            summaryState.numberOfEmbryosTransferred.day6 =
              summaryState.numberOfEmbryosTransferred.day6 === ''
                ? 1
                : summaryState.numberOfEmbryosTransferred.day6 + 1;

            summaryState.totalUsableEmbryos.day6 =
              summaryState.totalUsableEmbryos.day6 === ''
                ? 1
                : summaryState.totalUsableEmbryos.day6 + 1;
          }
        }

        if (oocyteRecord.day6.data[i].fate === 'Cryopreserve') {
          if (oocyteRecord.day6.data[i].day === '3') {
            summaryState.numberOfEmbryoCryopreserved.day3 =
              summaryState.numberOfEmbryoCryopreserved.day3 === ''
                ? 1
                : summaryState.numberOfEmbryoCryopreserved.day3 + 1;
            summaryState.totalUsableEmbryos.day3 =
              summaryState.totalUsableEmbryos.day3 === ''
                ? 1
                : summaryState.totalUsableEmbryos.day3 + 1;
          }
          if (oocyteRecord.day6.data[i].day === '5') {
            summaryState.numberOfEmbryoCryopreserved.day5 =
              summaryState.numberOfEmbryoCryopreserved.day5 === ''
                ? 1
                : summaryState.numberOfEmbryoCryopreserved.day5 + 1;

            summaryState.totalUsableEmbryos.day5 =
              summaryState.totalUsableEmbryos.day5 === ''
                ? 1
                : summaryState.totalUsableEmbryos.day5 + 1;
          }
          if (oocyteRecord.day6.data[i].day === '6') {
            summaryState.numberOfEmbryoCryopreserved.day6 =
              summaryState.numberOfEmbryoCryopreserved.day6 === ''
                ? 1
                : summaryState.numberOfEmbryoCryopreserved.day6 + 1;

            summaryState.totalUsableEmbryos.day6 =
              summaryState.totalUsableEmbryos.day6 === ''
                ? 1
                : summaryState.totalUsableEmbryos.day6 + 1;
          }
        }

        if (oocyteRecord.day6.data[i].fate === 'Embryobiopsy') {
          if (oocyteRecord.day6.data[i].day === '3') {
            summaryState.numberOfEmbryosBiopsy.day3 =
              summaryState.numberOfEmbryosBiopsy.day3 === ''
                ? 1
                : summaryState.numberOfEmbryosBiopsy.day3 + 1;
          }
          if (oocyteRecord.day6.data[i].day === '5') {
            summaryState.numberOfEmbryosBiopsy.day5 =
              summaryState.numberOfEmbryosBiopsy.day5 === ''
                ? 1
                : summaryState.numberOfEmbryosBiopsy.day5 + 1;
          }
          if (oocyteRecord.day6.data[i].day === '6') {
            summaryState.numberOfEmbryosBiopsy.day6 =
              summaryState.numberOfEmbryosBiopsy.day6 === ''
                ? 1
                : summaryState.numberOfEmbryosBiopsy.day6 + 1;
          }
        }

        if (oocyteRecord.day6.data[i].fate === 'Discard') {
          summaryState.numberOfEmbryosDiscarded =
            summaryState.numberOfEmbryosDiscarded === ''
              ? 1
              : summaryState.numberOfEmbryosDiscarded + 1;
        }
      }

      summaryState.normalFertilization = normalFertilizationCount;
      summaryState.gradeABCCount = `${gradeACount} Grade A + ${gradeBCount} Grade B + ${gradeCCount} Grade C`;
      summaryState.embryoDevelopment = embryoDevelopment;
    }

    dispatch(setEmbryologyData('summaryReport', summaryState));
  };

  useEffect(() => {
    const fetchSummaryReport = async () => {
      const response = await fetchEmbryologySummaryReport(
        data.selectedPatientData.patient.id,
        cycleId,
      );
      if (!response.data.result) {
        return;
      }
      console.log('response', response.data.result);
      setFormData(response.data.result);

      toast.success('Data fetched');
    };
    fetchSummaryReport();
  }, []);

  const handleInputChange = (e) => {
    if (isDisabled) return;
    const { name, value } = e.target;
    dispatch(setEmbryologyData(`summaryReport.${name}`, value));
  };

  const handleDateChange = (date, name) => {
    if (isDisabled) return;
    const dateString = date ?? '';
    dispatch(setEmbryologyData(`summaryReport.${name}`, dateString));
  };

  return (
    <div className="customer-profile">
      <h3>Clinical Assisted Reproduction Report (OPU)</h3>
      <div className="embryology-table">
        <div className="body" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1, padding: '0px 10px' }}>
            <tbody>
              <tr>
                <td>MRS:</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'name',
                    summaryReport.name,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
                <td>MR:</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'partnerName',
                    summaryReport.partnerName,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>MPI No:</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'mpiNo',
                    summaryReport.mpiNo,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
                <td>Date</td>
                <td>
                  <DateComponent
                    value={summaryReport.date}
                    name="date"
                    onChange={(date) => handleDateChange(date, 'date')}
                  />
                </td>
              </tr>
              <tr>
                <td>Treating Doctor</td>
                <td colSpan="3">
                  {renderInputFieldWithoutLabel(
                    'treatingDoctor',
                    summaryReport.treatingDoctor,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="body mt-4" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1, padding: '0px 10px' }}>
            <thead>
              <th colSpan={4}>Characteristics Of Cycle</th>
            </thead>
            <tbody>
              <tr>
                <td>Oocyte Origin</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'oocyteOrigin',
                    summaryReport.oocyteOrigin,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>Semen Origin</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'semenOrigin',
                    summaryReport.semenOrigin,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="body mt-4" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1, padding: '0px 10px' }}>
            <thead>
              <th colSpan={4}>Follicular Retrival</th>
            </thead>
            <tbody>
              <tr>
                <td>Oocyte Status</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'oocyteStatus',
                    summaryReport.oocyteStatus,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>Ovum Pick Up Date</td>
                <td>
                  <DateComponent
                    selectedDate={
                      summaryReport.ovumPickupDate
                        ? dayjs(summaryReport.ovumPickupDate)
                        : null
                    }
                    isDisabled={true}
                    name="ovumPickupDate"
                    onChange={(date) =>
                      handleDateChange(date, 'ovumPickupDate')
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>No of Oocytes Retrieved</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'retrievedOcc',
                    summaryReport.retrievedOcc,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="body mt-4" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1, padding: '0px 10px' }}>
            <thead>
              <th colSpan={4}>Oocytes</th>
            </thead>
            <tbody>
              <tr>
                <td>No of Mature Oocytes(MII)</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'noOfMatureOcytes',
                    summaryReport.noOfMatureOcytes,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>No of Immature Oocytes (MI/GV/Others)</td>
                <td>
                  MI:{' '}
                  {renderInputFieldWithoutLabel(
                    'noOfImmatureOocytes.mi',
                    summaryReport.noOfImmatureOocytes.mi,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                  GV:{' '}
                  {renderInputFieldWithoutLabel(
                    'noOfImmatureOocytes.gv',
                    summaryReport.noOfImmatureOocytes.gv,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                  Others:{' '}
                  {renderInputFieldWithoutLabel(
                    'noOfImmatureOocytes.others',
                    summaryReport.noOfImmatureOocytes.others,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>Total Oocytes for ICSI</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'totalOocytesForICSI',
                    summaryReport.totalOocytesForICSI,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>Total Oocytes for IVF</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'totalOocytesForIVF',
                    summaryReport.totalOocytesForIVF,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>Comments</td>
                <td>
                  <CustomTextArea
                    minRows={2}
                    maxRows={3}
                    name="oocytesComments"
                    value={summaryReport.oocytesComments}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="body mt-4" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1, padding: '0px 10px' }}>
            <thead>
              <th colSpan={5}>Sperm</th>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td colSpan={2}>
                  <strong>PRE-WASH</strong>
                </td>
                <td colSpan={2}>
                  <strong>POST-WASH</strong>
                </td>
              </tr>
              <tr>
                <td>Volume (mL)</td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'preWash.volume',
                    summaryReport.preWash.volume,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'postWash.volume',
                    summaryReport.postWash.volume,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>Concentration (million/mL)</td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'preWash.concentration',
                    summaryReport.preWash.concentration,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'postWash.concentration',
                    summaryReport.postWash.concentration,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>Motility(%)</td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'preWash.totalMotility',
                    summaryReport.preWash.totalMotility,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'postWash.totalMotility',
                    summaryReport.postWash.totalMotility,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>Comments</td>
                <td colSpan={4}>
                  <CustomTextArea
                    minRows={2}
                    maxRows={3}
                    name="spermComments"
                    value={summaryReport.spermComments}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="body mt-4" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1, padding: '0px 10px' }}>
            <thead>
              <th colSpan={3}>Fertilization And Cleavage Status</th>
            </thead>
            <tbody>
              <tr>
                <td>Normal Fertilization (2PB/2PN)</td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'normalFertilization',
                    summaryReport.normalFertilization,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>No of Grade A, B & C embryos on Day 2</td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'gradeABCCount',
                    summaryReport.gradeABCCount,
                    handleInputChange,
                    false,
                    null,
                    true,
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="body mt-4" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1, padding: '0px 10px' }}>
            <thead>
              <th colSpan={5}>Embryo Development</th>
            </thead>
            <tbody>
              <tr>
                <td>S.No</td>
                <td>Day</td>
                <td>Cell No./ Stage</td>
                <td>Grade</td>
                <td>State</td>
              </tr>
              {summaryReport.embryoDevelopment.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      `embryoDevelopment.${index}.day`,
                      item.day,
                      handleInputChange,
                      false,
                      null,
                      true,
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      `embryoDevelopment.${index}.cellNoOrStage`,
                      item.cellNoOrStage,
                      handleInputChange,
                      false,
                      null,
                      true,
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      `embryoDevelopment.${index}.grade`,
                      item.grade,
                      handleInputChange,
                      false,
                      null,
                      true,
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      `embryoDevelopment.${index}.state`,
                      item.state,
                      handleInputChange,
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="body mt-4" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1, padding: '0px 10px' }}>
            <thead>
              <th colSpan={3}>Summary of Embryos</th>
            </thead>
            <tbody>
              {/* <tr>
                <td>Total No. Of Usable Embryos</td>
                <td colSpan={2}>
                  Day 3:
                  {renderInputFieldWithoutLabel(
                    'totalUsableEmbryos.day3',
                    summaryReport.totalUsableEmbryos.day3,
                    handleInputChange,
                  )}
                  Day 5:
                  {renderInputFieldWithoutLabel(
                    'totalUsableEmbryos.day5',
                    summaryReport.totalUsableEmbryos.day5,
                    handleInputChange,
                  )}
                  Day 6:
                  {renderInputFieldWithoutLabel(
                    'totalUsableEmbryos.day6',
                    summaryReport.totalUsableEmbryos.day6,
                    handleInputChange,
                  )}
                </td>
              </tr> */}
              {/* <tr>
                <td>No of Embryos Tranferred</td>
                <td colSpan={2}>
                  Day 3:
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryosTransferred.day3',
                    summaryReport.numberOfEmbryosTransferred.day3,
                    handleInputChange,
                  )}
                  Day 5:
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryosTransferred.day5',
                    summaryReport.numberOfEmbryosTransferred.day5,
                    handleInputChange,
                  )}
                  Day 6:
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryosTransferred.day6',
                    summaryReport.numberOfEmbryosTransferred.day6,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>No of Embryos Biopsy</td>
                <td colSpan={2}>
                  Day 3:
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryosBiopsy.day3',
                    summaryReport.numberOfEmbryosBiopsy.day3,
                    handleInputChange,
                  )}
                  Day 5:
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryosBiopsy.day5',
                    summaryReport.numberOfEmbryosBiopsy.day5,
                    handleInputChange,
                  )}
                  Day 6:
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryosBiopsy.day6',
                    summaryReport.numberOfEmbryosBiopsy.day6,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>No of Embryos Cryopreserved</td>
                <td colSpan={2}>
                  Day 3:
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryoCryopreserved.day3',
                    summaryReport.numberOfEmbryoCryopreserved.day3,
                    handleInputChange,
                  )}
                  Day 5:
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryoCryopreserved.day5',
                    summaryReport.numberOfEmbryoCryopreserved.day5,
                    handleInputChange,
                  )}
                  Day 6:
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryoCryopreserved.day6',
                    summaryReport.numberOfEmbryoCryopreserved.day6,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>No of Embryos under observation</td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryoObservation',
                    summaryReport.numberOfEmbryoObservation,
                    handleInputChange,
                  )}
                </td>
              </tr> */}
              <tr>
                <td>No of Embryos Discarded</td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'numberOfEmbryosDiscarded',
                    summaryReport.numberOfEmbryosDiscarded,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Comments</td>
                <td colSpan={2}>
                  <CustomTextArea
                    minRows={2}
                    maxRows={3}
                    name="reportComments"
                    value={summaryReport.reportComments}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      Embryologist:{' '}
      {renderInputFieldWithoutLabel(
        'embryologist',
        summaryReport.embryologist,
        handleInputChange,
      )}
    </div>
  );
};

export default EmbryologySummaryReport;
